import React, { useState } from 'react';
import './ExamForm.css'; // reuse form style
import { useNavigate } from 'react-router-dom';
import Footer from '../../Footer';
import careerIcon from '../../../assets/Pages/Career/careerIcon.png'; // add this asset

const ExamForm = () => {
  const navigate = useNavigate();
  const [role, setRole] = useState('');
  const [userType, setUserType] = useState('');

  const handleStart = () => {
    if (!userType) return;
    if (userType === 'Staff' && !role) return; // block staff without selected role
    const basePath = `/exam`;
    const type = userType ? userType.toLowerCase() : 'applicant';
    const query = role ? `?type=${role.toLowerCase()}` : '';
    navigate(`${basePath}/${type}${query}`);
  };  

  return (
    <div>
      <div className='career-background-one-container'>
        <div className='container'>
          <div className='applicant-training-dashboard-container'>
            <img className='career-page-icon' src={careerIcon} alt="Pawsible Exams" />
            <h2 className='career-page-heading'>Exam: Start Your Pawsible Path</h2>
            <p className='career-page-paragraph'>
                Let us know your role so we can guide you to the right training and test experience.
            </p>

            <form className='applicant-form'>
              <div className="form-group">
                <label className='form-label'>Are you a...</label>
                <select className='form-select' value={userType} onChange={(e) => setUserType(e.target.value)} required>
                  <option value=''>Choose Type</option>
                  <option value='Applicant'>Applicant</option>
                  <option value='Staff'>Current Staff</option>
                </select>
              </div>

              {userType === 'Staff'
                ? (
                    <div className="form-group">
                    <label className='form-label'>Select Your Role</label>
                    <select className='form-select' value={role} onChange={(e) => setRole(e.target.value)}>
                      <option value=''>Choose Role</option>
                      <option value='Daycare'>Daycare</option>
                      <option value='Grooming'>Grooming</option>
                      <option value='Trainer'>Trainer</option>
                      <option value='Receptionist'>Receptionist</option>
                      <option value='Shuttle'>Shuttle Driver</option>
                      <option value='Manager'>Manager</option>
                      {/* <option value='Marketing'>Marketing</option> */}
                    </select>
                  </div>
                )
                : null
              }

              <div className='exam-button-container'>
                <button type='button' className='exam-button' onClick={handleStart}>
                    Begin Exam
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <hr />
      <Footer />
    </div>
  );
};

export default ExamForm;
